import ko from "knockout";
import { CustomElement } from "../../../core/CustomElement";

// @ts-ignore
ko.extenders.lowercase = (target: KnockoutObservable<string>) => {
  target.subscribe(function (newValue: string) {
    target(newValue.toLowerCase());
  });
  return target;
};

// @ts-ignore
ko.extenders.uppercase = function (target: KnockoutObservable<string>) {
  target.subscribe(function (newValue: string) {
    target(newValue.toUpperCase());
  });
  return target;
};

export default class TextInputVM {
  container: CustomElement = null;
  type: KnockoutObservable<string> = ko.observable("text");
  placeholder: KnockoutObservable<string> = ko.observable("");
  autocomplete: KnockoutObservable<string> = ko.observable("off");
  instantVal: KnockoutObservable<string> = ko.observable("");
  value: KnockoutObservable<string> = ko.observable("");
  focused: KnockoutObservable<boolean> = ko.observable(false);

  throttledVal: KnockoutComputed<string> = ko
    .computed(this.instantVal)
    .extend({ throttle: 400 });

  instantValSub: KnockoutSubscription = null;
  valueSub: KnockoutSubscription = null;
  throttledValSub: KnockoutSubscription = null;
  focusedSub: KnockoutSubscription = null;

  constructor(element: CustomElement) {
    this.container = element;
    this.listenToFocus();
  }

  // eslint-disable-next-line
  listenToFocus() {
    // eslint-disable-next-line
    const self = this;
    const input = self.container.shadowDom.querySelector("input");
    input.addEventListener("focus", () => {
      self.focused(true);
    });
    input.addEventListener("blur", () => {
      self.focused(false);
    });
  }

  // eslint-disable-next-line
  subscribeToInstantValue(fn: Function): void {
    if (this.instantValSub) {
      this.instantValSub.dispose();
    }

    this.instantValSub = this.instantVal.subscribe((newVal) => {
      fn.apply(this, [newVal]);
    });
  }

  applyLowercaseExtend(): void {
    this.instantVal.extend({ lowercase: true });
  }

  applyUppercaseExtend(): void {
    this.instantVal.extend({ uppercase: true });
  }

  subscribeToValue(fn: (value: string) => void): void {
    if (this.valueSub) {
      this.valueSub.dispose();
    }

    this.valueSub = this.value.subscribe((newVal) => {
      fn(newVal);
    });
  }

  // eslint-disable-next-line
  subscribeToTetheredValue(fn: Function): void {
    if (this.throttledValSub) {
      this.throttledValSub.dispose();
    }

    this.throttledValSub = this.throttledVal.subscribe((newVal) => {
      fn.apply(this, [newVal]);
    });
  }

  // eslint-disable-next-line
  subscribeToFocus(fn: Function): void {
    if (this.focusedSub) {
      this.focusedSub.dispose();
    }

    this.focusedSub = this.focused.subscribe((newVal) => {
      fn.apply(this, [newVal]);
    });
  }
}
